import classNames from 'classnames'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { useTranslation } from 'react-i18next'

import SubmitButton from '../../../../common/buttons/SubmitButton'
import { ReactComponent as CompletedIcon } from '../../../../../assets/images/common/icons/check-circle-white.svg'
import { ReactComponent as ModalXIcon } from '../../../../../assets/images/common/icons/modal-X-icon.svg'
import './ApproveEnrollmentModal.scss'
import Input from '../../../../common/form/Input'

const ApproveEnrollmentModal = ({ showModal, closeModal, coachMessage, handleCoachMessageChange, handleApproveEnrollment, isLoading }) => {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={closeModal}
      contentLabel={t('programs.manage.approveEnrollmentModal.contentLabel')}
      className={classNames('approve-enrollment-modal-content')}
      autoFocus
    >
      <div id='ApproveEnrollmentModal'>
        <div className='animated fadeIn'>
          <div className='d-flex justify-content-end text-align-right'>
            <ModalXIcon id='modalXIcon' onClick={closeModal} />
          </div>
          <div className='d-flex flex-column justify-content-center align-items-center'>
            <CompletedIcon id='completedIcon' />
            <p className='title'>{t('programs.manage.approveEnrollmentModal.title')}</p>
            <p className='sub-title mt-2'>{t('programs.manage.approveEnrollmentModal.subTitle')}</p>
            <Input
              name='description'
              type='textarea'
              onChange={handleCoachMessageChange}
              placeholder={t('programs.common.customMessageFamily')}
              value={coachMessage}
              classNames={{ inputContainer: 'coachMessageInputContainer', inputContainerWrapper: 'mt-3 coachMessageWrapper' }}
            />
          </div>
          <div>
            <div className='row py-3'>
              <div className='col-12'>
                <SubmitButton
                  loading={isLoading}
                  onClick={handleApproveEnrollment}
                  buttonMessage={t('programs.manage.approveEnrollmentModal.title')}
                  buttonColor='orange-button'
                />
              </div>
              <div className='col-12'>
                <SubmitButton
                  onClick={closeModal}
                  buttonMessage={t('common.cancel')}
                  buttonColor='navy-button'
                  disabled={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

ApproveEnrollmentModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  coachMessage: PropTypes.string,
  handleCoachMessageChange: PropTypes.func.isRequired,
  handleApproveEnrollment: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default ApproveEnrollmentModal
